<main id="main-content" class="pb-16">
  @if (authService.isAuthenticated() && authService.hasAcceptedCurrentTerms()) {
    <app-navigation />
    <app-read-only-banner />
  }
  <router-outlet />
</main>
<app-floating-chat />
